import { useMemo } from 'react';
import type { Image3D } from '~/domain/patient/image3d';
import type { Environment } from '~/engine/data/Environment';
import { useResidentEnvironments } from './useResidentEnvironments';

/**
 * The Environment the grid draws the image with: the first resident whose
 * primary image it is. `undefined` while no image is given or no
 * Environment shows it, and re-resolved when the residents change.
 */
export function useEnvironmentShowing(
    image: Image3D | undefined
): Environment | undefined {
    const residents = useResidentEnvironments();
    return useMemo(
        () =>
            image === undefined
                ? undefined
                : residents.find(
                      (environment) => environment.image?.parent === image
                  ),
        [residents, image]
    );
}
